import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import OwnerTrust from './OwnerTrust';
import OwnerBusiness from './OwnerBusiness';
import OwnerBOLM from './OwnerBOLM';
import OwnerRAL from './OwnerRAL';
import OwnerStateLand from './OwnerStateLand';
import WIOwnership from '../WIOwnership';
import WIContractOwnership from '../WIContractOwnership';
import OwnerJointTenant from './OwnerJointTenant';

export default class AddWIOwnership {
    id: number;
    horizonId: number;
    ownerType: number;
    individualOwner: OwnerIndividual;
    ownerTrust: OwnerTrust;
    businessOwner: OwnerBusiness;
    bolmOwner: OwnerBOLM;
    ralOwner: OwnerRAL;
    stateLandOwner: OwnerStateLand;
    ownerJointTenant: OwnerJointTenant;
    ownership: WIOwnership;
    contractOwnership: WIContractOwnership;
    ownerLookUpId: number;
    parentOwnershipId: number;

    static typedObject = (values: AddWIOwnership) => {
        const temp = new AddWIOwnership();

        if (values.id) {
            temp.id = parseInt(values.id + '', 10);
        }
        if (values.horizonId) {
            temp.horizonId = parseInt(values.horizonId + '', 10);
        }
        if (values.ownerType) {
            temp.ownerType = parseInt(values.ownerType + '', 10);
        }
        if (values.ownerLookUpId) {
            temp.ownerLookUpId = parseInt(values.ownerLookUpId + '', 10);
        }
        if (values.parentOwnershipId) {
            temp.parentOwnershipId = parseInt(values.parentOwnershipId + '', 10);
        }

        if (values.ownership) {
            temp.ownership = new WIOwnership();
            temp.ownership.decimalInterest = values.ownership.decimalInterest;
        }
        if (values.contractOwnership) {
            temp.contractOwnership = new WIContractOwnership();
            temp.contractOwnership.decimalInterest = values.contractOwnership.decimalInterest;
        }
        if (values.individualOwner) {
            temp.individualOwner = values.individualOwner;
        }
        if (values.ownerTrust) {
            temp.ownerTrust = values.ownerTrust;
        }
        if (values.businessOwner) {
            temp.businessOwner = values.businessOwner;
        }
        if (values.bolmOwner) {
            temp.bolmOwner = values.bolmOwner;
        }
        if (values.ralOwner) {
            temp.ralOwner = values.ralOwner;
        }
        if (values.stateLandOwner) {
            temp.stateLandOwner = values.stateLandOwner;
        }
        if (values.ownerJointTenant) {
            temp.ownerJointTenant = values.ownerJointTenant;
        }

        return temp;
    };
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/AddWIOwnership.ts